import React from 'react'
import { useTranslation } from 'react-i18next'
import InvoiceStatus from '../../TableTdElements/InvoiceStatus'
import TableTdElementsTooltip from '../../TableTdElements/TableTdElementsTooltip'
import { getInvoiceViewStatus, INVOICE_STATUS, isPostPaymentInvoice } from '../constants'
import { getPaymentMethodNames } from '../helper'
import { InvoicePaymentMethods } from './index.styled'

const InvoiceStatusCell = React.memo(({ item }) => {
	const { t } = useTranslation()
	const isManuallyMarkedPaid = !isPostPaymentInvoice(item) && getInvoiceViewStatus(item) === INVOICE_STATUS.PAID
	const paymentMethods = getPaymentMethodNames(item.paymentMethods, t)

	if (isManuallyMarkedPaid) {
		return (
			<TableTdElementsTooltip text={t('invoices.table.manuallyMarkedPaid')}>
				<InvoiceStatus item={item} />
			</TableTdElementsTooltip>
		)
	}

	return (
		<>
			<InvoiceStatus item={item} />
			{paymentMethods && <InvoicePaymentMethods data-testid="invoice-payment-methods">{paymentMethods}</InvoicePaymentMethods>}
		</>
	)
})

InvoiceStatusCell.displayName = 'InvoiceStatusCell'
export default InvoiceStatusCell
